import { render, staticRenderFns } from "./NavbarBuilderV2.vue?vue&type=template&id=4f335e7a&scoped=true"
import script from "./NavbarBuilderV2.vue?vue&type=script&lang=js"
export * from "./NavbarBuilderV2.vue?vue&type=script&lang=js"
import style0 from "./NavbarBuilderV2.vue?vue&type=style&index=0&id=4f335e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f335e7a",
  null
  
)

export default component.exports